var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoUnfilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5ZM0 10.75C0 4.81294 4.81294 0 10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75ZM9.99998 6.75C9.99998 6.33579 10.3358 6 10.75 6H10.76C11.1742 6 11.51 6.33579 11.51 6.75C11.51 7.16421 11.1742 7.5 10.76 7.5H10.75C10.3358 7.5 9.99998 7.16421 9.99998 6.75ZM10.75 9.99998C11.1642 9.99998 11.5 10.3358 11.5 10.75V14.75C11.5 15.1642 11.1642 15.5 10.75 15.5C10.3358 15.5 9.99998 15.1642 9.99998 14.75V10.75C9.99998 10.3358 10.3358 9.99998 10.75 9.99998Z",
    fill: "#070FED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoUnfilled);
export default __webpack_public_path__ + "static/media/info-unfilled.304177896cee69bf385d757057725458.svg";
export { ForwardRef as ReactComponent };